/**
 * 장착한 CITY를 작은 아이콘으로 표시 (MY 프로필, SPOT 레이더, 랜드마크 소유자).
 * 장착이 없으면 null 반환 — 레이아웃 영향 없음.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IoBusiness } from 'react-icons/io5';
import { useCityEquippedCache } from '../../contexts/CityEquippedCacheContext'; // 🎯 [CityCache] Hook 변경
import { CITY_KEYS } from '../../features/city/constants';
// import { getEnvironment } from '../../utils/environment'; // Context에서 처리하므로 불필요

const ICON_SIZE = 18;

const CityIcon = ({ userId, size = ICON_SIZE, style = {} }) => {
  const { t } = useTranslation();
  const { getCachedCityEquipped } = useCityEquippedCache();
  const [equipped, setEquipped] = React.useState([]);
  const [imgError, setImgError] = React.useState(false);

  React.useEffect(() => {
    let isMounted = true;

    if (!userId) {
      setEquipped([]);
      return;
    }

    const load = async () => {
      const data = await getCachedCityEquipped(userId);
      if (isMounted) {
        setEquipped(data || []);
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, [userId, getCachedCityEquipped]);

  React.useEffect(() => {
    setImgError(false);
  }, [userId]);

  if (!userId || !Array.isArray(equipped) || equipped.length === 0) {
    return null;
  }

  const token = equipped[0];
  const imageUrl = token.thumbnailUrl || token.imageUrl || null;

  const content = imageUrl && !imgError ? (
    <img
      src={imageUrl}
      alt=""
      role="presentation"
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      onError={() => setImgError(true)}
      style={{
        width: size,
        height: size,
        objectFit: 'cover',
        borderRadius: 4,
        flexShrink: 0,
      }}
    />
  ) : (
    <IoBusiness size={size} color="#FFD700" style={{ flexShrink: 0 }} />
  );

  return (
    <span
      title={t(CITY_KEYS.ICON_LABEL)}
      aria-label={t(CITY_KEYS.ICON_LABEL)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: 4,
        ...style,
      }}
    >
      {content}
    </span>
  );
};

export default CityIcon;
